import { render, staticRenderFns } from "./LegalFooterLinks.vue?vue&type=template&id=2b307fd2&scoped=true&"
import script from "./LegalFooterLinks.vue?vue&type=script&lang=js&"
export * from "./LegalFooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./LegalFooterLinks.vue?vue&type=style&index=0&id=2b307fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b307fd2",
  null
  
)

export default component.exports